/**
 * @generated SignedSource<<c959523f4ae0c4bf7f364d9bc942f211>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type IssueCommentViewerMarkdownViewer$data = {
  readonly body: string;
  readonly bodyHTML: string;
  readonly id: string;
  readonly viewerCanUpdate: boolean;
  readonly " $fragmentType": "IssueCommentViewerMarkdownViewer";
};
export type IssueCommentViewerMarkdownViewer$key = {
  readonly " $data"?: IssueCommentViewerMarkdownViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"IssueCommentViewerMarkdownViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "IssueCommentViewerMarkdownViewer",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "body",
      "storageKey": null
    },
    {
      "alias": null,
      "args": [
        {
          "kind": "Literal",
          "name": "unfurlReferences",
          "value": true
        }
      ],
      "kind": "ScalarField",
      "name": "bodyHTML",
      "storageKey": "bodyHTML(unfurlReferences:true)"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "viewerCanUpdate",
      "storageKey": null
    }
  ],
  "type": "IssueComment",
  "abstractKey": null
};

(node as any).hash = "522a6145a5b1a032a98ededa3a159869";

export default node;
